import React from 'react';
import PropTypes from 'prop-types';
import StepZero from './StepZero';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';
import StepFive from './StepFive';
import StepSix from './StepSix';

const CurrentStep = ({ activeStep, data, onNext, onBack, onSubmit }) => {
  if (activeStep === 1) {
    return <StepZero data={data} handleNext={onNext} handleBack={onBack} />;
  }
  if (activeStep === 2) {
    return <StepOne data={data} handleNext={onNext} handleBack={onBack} />;
  }
  if (activeStep === 3) {
    return <StepTwo data={data} handleNext={onNext} handleBack={onBack} />;
  }
  if (activeStep === 4) {
    return <StepThree data={data} handleNext={onNext} handleBack={onBack} />;
  }
  if (activeStep === 5) {
    return <StepFour data={data} handleNext={onNext} handleBack={onBack} />;
  }
  if (activeStep === 6) {
    return <StepFive data={data} handleNext={onNext} handleBack={onBack} />;
  }
  if (activeStep === 7) {
    return <StepSix data={data} onSubmit={onSubmit} handleBack={onBack} />;
  }

  return <StepSix data={data} onSubmit={onSubmit} handleBack={onBack} />;
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  data: PropTypes.any.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default CurrentStep;
